var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.284,
    height: 28.284,
    viewBox: "0 0 28.284 28.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel-circle",
    transform: "translate(0 -0.002)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M28.284,14.144a13.853,13.853,0,0,1-1.9,7.1,14.041,14.041,0,0,1-5.148,5.148,13.853,13.853,0,0,1-7.1,1.9,13.853,13.853,0,0,1-7.1-1.9A14.041,14.041,0,0,1,1.9,21.243a13.853,13.853,0,0,1-1.9-7.1,13.853,13.853,0,0,1,1.9-7.1A14.041,14.041,0,0,1,7.043,1.9a13.853,13.853,0,0,1,7.1-1.9,13.853,13.853,0,0,1,7.1,1.9,14.041,14.041,0,0,1,5.148,5.148A13.853,13.853,0,0,1,28.284,14.144ZM18.7,20.706,20.7,18.7,16.15,14.144,20.7,9.591,18.7,7.582l-4.554,4.554L9.588,7.582,7.58,9.591l4.554,4.554L7.58,18.7l2.008,2.008,4.554-4.554Z",
    transform: "translate(0 -0.002)",
    fill: "#c3c3c3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircle);
export default __webpack_public_path__ + "static/media/cancel-circle.e68cc2f22ecc9eabf571d04569b7860f.svg";
export { ForwardRef as ReactComponent };